/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Save_Failed1Inputs */

const vi_guidevideo_save_failed1 = /** @type {(inputs: Guidevideo_Save_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được video hướng dẫn. Kiểm tra các ô rồi thử lại.`)
};

/**

* @param {Guidevideo_Save_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_save_failed1 = /** @type {((inputs?: Guidevideo_Save_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Save_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_save_failed1(inputs)
});
export { guidevideo_save_failed1 as "guideVideo_save_failed" }